// extracted by mini-css-extract-plugin
export var cancelButton = "_oc-5";
export var content = "_oc-3";
export var createButton = "_oc-6";
export var drawerContainer = "_oc-0";
export var footer = "_oc-2";
export var header = "_oc-1";
export var orderFormColumn = "_oc-4";